import { FC } from 'react';
import { graphql, createFragmentContainer } from 'react-relay/legacy';

import { useAuctionState } from 'dibs-auctions/exports/hooks';

// Components
import { PdpSharedSocialSharePinterest } from '../shared/PdpSharedSocialShare/PdpSharedSocialSharePinterest';
import { PdpSharedSocialShareFacebook } from '../shared/PdpSharedSocialShare/PdpSharedSocialShareFacebook';
import { PdpSharedSocialShareEmail } from '../shared/PdpSharedSocialShare/PdpSharedSocialShareEmail';
import { PdpRespIconBubbleShare } from './PdpRespIconBubbleShare';

import { PdpRespIconBubbles_viewer$data } from './__generated__/PdpRespIconBubbles_viewer.graphql';
import { PdpRespIconBubbles_item$data } from './__generated__/PdpRespIconBubbles_item.graphql';
import { PdpRespIconBubbles_user$data } from './__generated__/PdpRespIconBubbles_user.graphql';
import { useServerVarsContext } from '../../global/ServerVarsContext/ServerVarsContext';

type Props = {
    viewer: PdpRespIconBubbles_viewer$data;
    item: PdpRespIconBubbles_item$data;
    user: PdpRespIconBubbles_user$data | null | undefined;
    skuId?: string;
};

const PdpTabletIconBubbles: FC<Props> = ({ item, skuId, user, viewer }) => (
    <>
        <PdpSharedSocialSharePinterest variant="iconBubble" item={item} />
        <PdpSharedSocialShareFacebook variant="iconBubble" item={item} />
        <PdpSharedSocialShareEmail
            variant="iconBubble"
            item={item}
            user={user}
            viewer={viewer}
            skuId={skuId}
        />
    </>
);

const PdpRespIconBubblesComponent: FC<Props> = props => {
    const { isDesktop } = useServerVarsContext();

    const { isAuctionEnabled } = props.item;
    const { isActiveAuction, isPreviewAuction } = useAuctionState({ item: props.item });

    if (isAuctionEnabled && !(isActiveAuction || isPreviewAuction)) {
        //if auction is enabled show icons only on active or preview auctions
        return null;
    }

    return isDesktop ? <PdpRespIconBubbleShare {...props} /> : <PdpTabletIconBubbles {...props} />;
};

export const PdpRespIconBubbles = createFragmentContainer(PdpRespIconBubblesComponent, {
    viewer: graphql`
        fragment PdpRespIconBubbles_viewer on Viewer {
            ...PdpSharedSocialShareEmail_viewer
            ...PdpRespIconBubbleShare_viewer
        }
    `,
    item: graphql`
        fragment PdpRespIconBubbles_item on Item {
            isAuctionEnabled
            ...PdpSharedSocialSharePinterest_item
            ...PdpSharedSocialShareFacebook_item
            ...PdpSharedSocialShareEmail_item
            ...PdpRespIconBubbleShare_item
            ...useAuctionState_item @arguments(page: pdp)
        }
    `,
    user: graphql`
        fragment PdpRespIconBubbles_user on User {
            ...PdpSharedSocialShareEmail_user
            ...PdpRespIconBubbleShare_user
        }
    `,
});
